import axios from "axios";

const { REACT_APP_SERVER_URL: SERVER_URL } = process.env;
const BASE_URL = `${SERVER_URL}/business-challenge`;

async function getVotingDetails(token) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  try {
    const { data } = await axios.get(`${BASE_URL}/voting`);

    return data;
  } catch (e) {
    throw e;
  }
}

async function getContestants(token, id) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  try {
    const { data } = await axios.get(`${BASE_URL}/contestants`);
    return data;
  } catch (e) {
    throw e;
  }
}

async function vote(token, voteData) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  try {
    const { data } = await axios.post(`${BASE_URL}/vote`, voteData);
    return data;
  } catch (e) {
    throw e;
  }
}

export default {
  getVotingDetails,
  getContestants,
  vote,
};
